<template>
  <div class="game mx-auto flex h-full  select-none relative" :class="{ 'isSpymaster': isSpymaster, 'red_agent': double_agent[0] === 'red_agent', 'blue_agent': double_agent[0] === 'blue_agent' }">
    <div
      @click="canShowOverlay = !canShowOverlay"
      v-show="gameover && canShowOverlay"
      class="gameover border-2 border-black cursor-pointer pin-t-0 pin-l-0 p-0 absolute w-full h-full  z-40 bg-blue-500 flex items-center justify-center"
      style='opacity: .9'
      :class="{
        'assassin': counted_types['assassin'] === undefined,
        'red_agent': counted_types['red_agent'] === undefined,
        'blue_agent': counted_types['blue_agent'] === undefined
      }"
    >
      <div class="">
        <div class="uppercase font-semibold text-white tracking-wide italic leading-none text-center" style="font-size: 64px;">
          <span class="assassin_text hidden">You've been assassinated 🔫</span>
          <span class="red_text hidden">Red team wins</span>
          <span class="blue_text hidden">Blue team wins</span>
        </div>
        <div class="mt-8 text-center">
          <router-link :to="{ name: 'index' }" class="px-4 p-2 uppercase bg-white text-black rounded-md text-sm shadow-md normal font-medium hover:opacity-75">New Game</router-link>
        </div>
      </div>
    </div>
    <transition-group name="shuffleInstant" tag="div" class="flex-grow deck flex flex-wrap h-full cursor-pointer">
      <game-card
        v-for="item in collection"
        :key="item.word"
        :isSpymaster="isSpymaster"
        :item="item"
        @clicked="clicked"
      />
    </transition-group>
    <div v-show="!isSpymaster" class="border-2 border-l-0 border-black">
      <div
        v-for="item in sortedCollection"
        :key="`mini-${item.word}`"
        class="mini-game-card w-8 h-6 bg-black border-b-2 border-black"
        :class="{
          [item.type]: true,
          'hidden': item.active
        }"
      ></div>
      <div class="mini-game-card w-8 h-6 bg-black border-b-2 border-black"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { db } from '@/utils/firebase-config'
import shuffleSeed from 'shuffle-seed'
import GameCard from '@/components/game-card'

// App
export default {
  components: {
    GameCard
  },

  data () {
    return {
      canShowOverlay: true,
      collection: [],
      double_agent: '',
      isSpymaster: false,
      key: [],
      seed: null
    }
  },

  created () {
    this.seed = this.$route.params.id
    this.isSpymaster = this.$route.params.isSpymaster == 'true'

    this.buildKey()
    this.buildCollection()
    this.firebase_init()
  },

  computed: {
    collection_types () {
      return [...this.collection]
        .filter(i => i.active === false)
        .map(i => i.type)
    },

    counted_types () {
      const counts = {}
      this.collection_types.forEach(x => { counts[x] = (counts[x] || 0)+1 })
      return counts
    },

    gameover () {
      return (
        this.counted_types['assassin'] === undefined ||
        this.counted_types['red_agent'] === undefined ||
        this.counted_types['blue_agent'] === undefined
      )
    },

    sortedCollection () {
      function compare(a, b) {
        if (a.type < b.type)
          return -1;
        if (a.type > b.type)
          return 1;
        return 0;
      }

      return [...this.collection].sort(compare)
    }
  },

  methods: {
    buildCollection () {
      // collect all words
      const words = [...this.$store.state.words]

      // shuffle the images with the seed
      const shuffledWords = shuffleSeed.shuffle(words, this.seed)

      this.collection = shuffledWords.slice(0, 25).map((w, index) => {
        return {
          active: false,
          type: this.key[index],
          word: w
        }
      })
    },

    buildKey () {
      this.double_agent = shuffleSeed.shuffle(['red_agent', 'blue_agent'], this.seed).slice(0, 1)
      // shuffle the images with the seed
      let key = []

      key = [...key, 'assassin']
      key = [...key, 'red_agent', 'red_agent', 'red_agent', 'red_agent', 'red_agent', 'red_agent', 'red_agent', 'red_agent']
      key = [...key, 'blue_agent', 'blue_agent', 'blue_agent', 'blue_agent', 'blue_agent', 'blue_agent', 'blue_agent', 'blue_agent']
      key = [...key, ...this.double_agent]
      key = [...key, 'bystander', 'bystander', 'bystander', 'bystander', 'bystander', 'bystander', 'bystander']

      // shuffle the images with the seed
      const shuffledKey = shuffleSeed.shuffle(key, this.seed)

      this.key = shuffledKey
    },

    async clicked (item) {
      // replace item in local collection
      Vue.set(this.collection, this.collection.findIndex(i => i.word === item.word), item)

      await this.firebase_update()

      // make overlay displayable
      this.canShowOverlay = true
    },

    async firebase_init () {
      const gamesDoc = db
        .collection('games')
        .doc(this.seed)

      const doc = await gamesDoc.get()

      if (!doc.exists) {
        // create document in Firebase
        await gamesDoc.set(
          { collection: this.collection },
          { merge: true }
        )
      }

      // listen for changes
      await gamesDoc.onSnapshot(snapshot => {
        this.collection = snapshot.data().collection
      })
    },

    firebase_update () {
      return db
        .collection('games')
        .doc(this.seed)
        .set({ collection: this.collection }, {merge: true});
    }
  }
}
</script>

<style>
  .deck {
    @apply border border-black;
  }

  .shuffleFast-move {
    transition: transform 0.5s;
  }

  .shuffleInstant-move {
    transition: transform 0s;
  }

  .game.isSpymaster {
    @apply h-64 w-64;
  }

  .game.red_agent { border: 2px solid #e84333; }
  .game.blue_agent { border: 2px solid #375aee; }

  .mini-game-card.assassin { background-color: #212121 }
  .mini-game-card.red_agent { background-color: #e84333 }
  .mini-game-card.blue_agent { background-color: #375aee }
  .mini-game-card.bystander { background-color: #ccbfa9 }

  .gameover.assassin { background-color: #212121 }
  .gameover.red_agent { background-color: #e84333 }
  .gameover.blue_agent { background-color: #375aee }

  .gameover.assassin .assassin_text,
  .gameover.red_agent .red_text,
  .gameover.blue_agent .blue_text {
    @apply block;
  }
</style>
